export const LOADING = 'LOADING'
export const LANGUAGE = 'LANGUAGE'
export const USER = 'USER'
export const CLEARUSER = 'CLEARUSER'
export const INCREASE = 'INCREASE'
export const DECREASE = 'DECREASE'
export const APPID = 'APPID'
export const PAGEID = 'PAGEID'
export const RESETCOUNT = 'RESETCOUNT'



// WEBPACK FOOTER //
// ./src/store/mutations_types.js